import { useNavigate } from "react-router-dom";
import { PODCAST_LIST_ROUTE, PODCAST_ADD_ROUTE } from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { X } from "lucide-react";
import { useFormik } from "formik";
import { showNotification } from "Common/utils/Notification";
import { useState, useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import { imageUploader } from "Common/utils/imageUploader";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import { ToastContainer } from "react-toastify";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import BreadCrumb from "../../Common/BreadCrumb";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import video from "../../images/video.svg";
import audio from "../../images/Speaker_Icon.svg";
import ToggleSwitch from "Common/Components/ToggleSwitch/ToggleSwitch";
import ThumbnailEdit from "pages/media/ThumbnailEdit";

const AddPodcast = () => {
  const navigate = useNavigate();
  const [imageLink, setImageLink] = useState<any>();
  const [thumbnailUrl, setThumbnailUrl] = useState<any>({
    thumbnail_url: "",
    thumbnail_id: "",
  });
  const [mediaType, setMediaType] = useState<any>("");
  const [loader, setLoader] = useState<any>(false);
  const [imageData, setImageData] = useState<any>("");
  const [index, setIndex] = useState<any>(undefined);
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (index === undefined) {
        if (
          imageData?.media_type === "audio" ||
          imageData?.media_type === "video"
        ) {
          setImageLink(imageData);
          setMediaType(imageData?.media_type);
        } else {
          showNotification(
            "The media type should be either audio or video.",
            "error"
          );
        }
      } else if (index === "media") {
        if (imageData?.media_type === "image") {
          setThumbnailUrl((prev) => ({
            ...prev,
            ["thumbnail_url"]: imageData?.media_url,
          }));
          setThumbnailUrl((prev) => ({
            ...prev,
            ["thumbnail_id"]: imageData?._id,
          }));
        } else {
          showNotification("The media type should be image", "error");
        }
      }
    }
  }, [imageData, thumbnailUrl, index]);
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);
  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      heading: "",
      is_visible: false,
      // podcast_url: imageLink?.media_url || "",
    },
    validationSchema: Yup.object({
      heading: Yup.string().required("Please enter heading"),
      is_visible: Yup.boolean().required("Please select is active"),
      // podcast_url: Yup.string().required("Please enter podcast url"),
    }),

    onSubmit: async (values) => {
      const updateData = {
        ...values,
      };
      if (!!!imageLink?.media_url) {
        showNotification("Please add image", "error");
        return;
      }
      if (!!!thumbnailUrl?.thumbnail_url) {
        showNotification("Please add image", "error");
        return;
      }

      try {
        setLoader(true);
        const res = await callApi(`v1/podcast/new`, "post", {
          podcast: {
            podcast_url: imageLink?.media_url,
            // thumbnail_media_id: imageLink?._id,
            content_type: imageLink?.content_type,
            heading: values?.heading,
            is_active: values?.is_visible,
            ...thumbnailUrl,
            podcast_media_type: mediaType,
          },
        });
        setLoader(false);
        if (res && res?.status === "Success") {
          showNotification("Podcast created successfully", "success");
          setImageLink("");

          setLoader(true);
          setTimeout(() => {
            navigate(PODCAST_LIST_ROUTE);
            setLoader(false);
          }, 1000);
        }
      } catch (e) {
        showNotification("something went wrong", "error");
      }
    },
  });

  return (
    <>
      <BreadCrumb
        title={PODCAST_ADD_ROUTE}
        pageTitle={PODCAST_LIST_ROUTE}
        version="v1"
      />
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <div className="xl:col-span-12">
                <ToggleSwitch
                  selectValue={validation.values.is_visible || false}
                  versionValue={false}
                  toggle={() =>
                    validation.setFieldValue(
                      "is_visible",
                      !validation.values.is_visible
                    )
                  }
                  label="Is Active?"
                  required={true}
                />
              </div>
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Heading
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Heading"
                    name="heading"
                    onChange={validation.handleChange}
                    value={validation.values.heading || ""}
                  />
                  {validation.touched.heading && validation.errors.heading ? (
                    <p className="text-red-400">{validation.errors.heading}</p>
                  ) : null}
                </div>
              </div>
              <div className="m-4 ml-0 xl:col-span-12">
                {imageLink ? (
                  <div className="flex items-center">
                    <div className="relative w-40 h-40 ">
                      {imageLink?.media_type === "video" ? (
                        <img src={video} alt="img" className="w-40 h-40" />
                      ) : (
                        <img src={audio} alt="img" className="w-40 h-40" />
                      )}
                      <span
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "6px",
                          fontSize: "22px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setImageData(null);
                          setImageLink(null);
                          setIndex(undefined);
                        }}
                      >
                        ×
                      </span>
                    </div>
                    <div className="h-3 ml-3">
                      <div
                        onClick={() => {
                          setImageData(undefined);
                          setIndex(undefined);
                          toggleImage();
                        }}
                        // htmlFor="uploadimage49"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        setImageData(undefined);
                        toggleImage();
                        setIndex(undefined);
                      }}
                      //htmlFor="uploadimage59"
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Media"}
                    </div>
                  </>
                )}
              </div>
              <div className="m-4 ml-0 xl:col-span-12">
                {thumbnailUrl?.thumbnail_url ? (
                  <div className="flex items-center">
                    <div className="relative w-40 h-40 ">
                      <img
                        src={getImageUrl(thumbnailUrl?.thumbnail_url)}
                        alt="img"
                        className="w-40 h-40"
                      />

                      <span
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "6px",
                          fontSize: "22px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setImageData(null);
                          setIndex("media");
                          setThumbnailUrl((prev) => ({
                            ...prev,
                            ["thumbnail_url"]: null,
                          }));
                          setThumbnailUrl((prev) => ({
                            ...prev,
                            ["thumbnail_id"]: null,
                          }));
                        }}
                      >
                        ×
                      </span>
                    </div>
                    <div className="h-3 ml-3">
                      <div
                        onClick={() => {
                          setImageData(undefined);
                          toggleImage();
                          setIndex("media");
                        }}
                        // htmlFor="uploadimage49"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        setImageData(undefined);
                        toggleImage();
                        setIndex("media");
                      }}
                      //htmlFor="uploadimage59"
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Thumbnail"}
                    </div>
                  </>
                )}
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(PODCAST_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loader}
                  id="addNew"
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : (
                    "Add podcast"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Add Media"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default AddPodcast;
